<div class="pb-5 px-md-5 mt-md-5">
  <h2 class="text-info mb-4">Voici un résumé de tes réponses et les éléments d'analyse que nous te proposons :</h2>

  <div class="row g-3 mb-5">
    <div class="col-12 col-lg-4" *ngFor="let answer of paginatedAnswers">
      <div class="card-answer">
        <div class="card-answer-header">
          <p class="card-answer-question">{{ answer.question }}</p>
          <div class="card-answer-response">
            <span class="card-answer-label">Votre réponse</span>
            <div class="d-flex align-items-center justify-content-between gap-2">
              <span class="card-answer-value">{{ answer.answer }}</span>
              <button class="card-answer-toggle" (click)="toggleAnswer(answer)">
                <span class="material-icons">{{ answerOpened === answer ? 'remove' : 'add' }}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="card-answer-solutions" *ngIf="answerOpened === answer">
          <ng-container *ngFor="let solution of answer.solutions">
            <p class="solution-content">{{ solution.content }}</p>
            <a href="{{ solution.link }}" target="_blank" class="btn btn-primary btn-sm" *ngIf="solution.link">Voir l'article</a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <nav aria-label="Pagination">
    <ul class="pagination-custom">
      <li class="page-item-custom" [class.disabled]="currentPage === 1">
        <a class="page-link-custom" (click)="prevPage()">
          <span class="material-icons">chevron_left</span>
        </a>
      </li>

      <li class="page-item-custom" [class.active]="currentPage === 1">
        <a class="page-link-custom" (click)="goToPage(1)">1</a>
      </li>

      <li class="page-item-custom" *ngIf="shouldShowEllipsisBefore()">
        <span class="page-link-custom">...</span>
      </li>

      <li class="page-item-custom" *ngFor="let page of getMiddlePages()" [class.active]="currentPage === page">
        <a class="page-link-custom" (click)="goToPage(page)">{{ page }}</a>
      </li>

      <li class="page-item-custom" *ngIf="shouldShowEllipsisAfter()">
        <span class="page-link-custom">...</span>
      </li>

      <li class="page-item-custom" [class.active]="currentPage === totalPages.length">
        <a class="page-link-custom" (click)="goToPage(totalPages.length)">{{ totalPages.length }}</a>
      </li>

      <li class="page-item-custom" [class.disabled]="currentPage === totalPages.length">
        <a class="page-link-custom" (click)="nextPage()">
          <span class="material-icons">chevron_right</span>
        </a>
      </li>
    </ul>
  </nav>
</div>
